import React from 'react';
import './AboutUs.scss'

const AboutUs = () => {

  return (
    <div className="about-us">
      <h2 className="title-page">About Us</h2>
      <p  className="about-us__description">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed pellentesque lectus vel purus consequat fringilla.
        Mauris eu volutpat sem, in egestas magna
      </p>

      <div className="about-us__group about-us__bg">
        <div className="about-us__row">
          <div className="about-us__block-item">
            <p className="about-us__block-number">1.</p>
            <p className="about-us__block-label">You book a tour</p>
          </div>
          <div className="about-us__block about-us__block_operator">
            <img src="/assets/img/tour-operator.png" alt="Tour operator" />
            <p className="about-us__block-label">Tour operator</p>
          </div>
          <div className="about-us__block-item">
            <p className="about-us__block-number">2.</p>
            <p className="about-us__block-label">Each tour operator provides you with vendor</p>
          </div>
        </div>
        <div className="about-us__bg-footer">
          <div className="about-us__block">
            <img src="/assets/img/user.png" alt="User" />
            <p className="about-us__block-label">User</p>
          </div>
          <div className="about-us__block-item">
            <p className="about-us__block-number">3.</p>
            <p className="about-us__block-label">Vendor delivers you to the tour place</p>
          </div>
          <div className="about-us__block">
            <img src="/assets/img/vendor.png" alt="Tour operator" />
            <p className="about-us__block-label">Vendor</p>
          </div>

        </div>
      </div>
    </div>
  )
};

export default AboutUs;


// WEBPACK FOOTER //
// ./src/app/containers/StaticPages/AboutUs.js